import React, {Fragment} from 'react'
import Select from "react-select";
import SelectBase from "./components/global/SelectBase";
import DropdownIndicator from './components/global/DropdownIndicator';
import SingleValue from './components/select-filter/SingleValue';
import Menu from './components/select-filter/Menu';
import MenuList from './components/select-filter/MenuList';
import Option from './components/select-filter/Option';
import SelectChips from "./components/SelectChips";
import '../../../assets/sass/components/react-select.scss';
import SelectSearch from "./SelectSearch";

class SelectFilter extends SelectBase {

    componentDidUpdate(prevProps) {
        if(this.props.menuPosition) {
            var select = this.select.current.select.controlRef;
            var menu = this.select.current.select.menuListRef;
            this.setMenuPosition(select, menu);
        }
    }

    render() {
        return (
            <Fragment>
                <Select
                    {...this.props}
                    ref={this.select}
                    name={this.props.name}
                    type={this.props.type}
                    placeholder={this.props.placeholder}
                    classNamePrefix="react-select"
                    className={ this.setClasses(this.props,'filter-checkbox') }
                    classNameMenu="react-select-filter-menu"
                    // defaultValue={this.state.inOptions[0]}
                    options={this.state.inOptions}
                    selectedOptions={this.state.selectedOptions}
                    selected={this.props.selected ?? false}
                    clearSelected={this.clearSelected}
                    removeSelected={this.removeSelected}
                    // filterOption={this.filterOptions}
                    isSearchable={false}
                    closeMenuOnSelect={false}
                    closeMenuOnScroll={true}
                    isClearable={false}
                    filterButtons={this.filterButtons}
                    isAllChecked={this.state.isAllChecked}
                    selectedAllChecked={this.state.selectedAllChecked}
                    onCheckChange={this.onCheckChange}
                    onMenuOpen={this.onMenuOpen}
                    onMenuClose={this.onMenuClose}
                    onDoneClick={this.onDoneClick}
                    onCloseClick={this.onCloseClick}
                    menuIsOpen={this.props.menuIsOpen ?? this.state.menuIsOpen}
                    arrowAutoPlacement={this.arrowAutoPlacement}
                    menuPositionStartSelector={this.menuPositionStartSelector}
                    maxMenuHeight="auto"
                    components={{
                        Menu,
                        MenuList,
                        Option,
                        DropdownIndicator,
                        SingleValue,
                        IndicatorSeparator: () => null
                    }}
                    styles={{
                        /*control: (base, state) => {
                            var change = {};
                            return Object.assign(base, change);
                        }*/
                    }}
                />
                <SelectChips show={this.props.showTag ?? false} options={this.state.selectedOptions} allChecked={!this.state.selectedAllChecked} removetag={this.removeSelected} />
            </Fragment>
        )
    }
}

SelectFilter.options = (options) => options.map((option, index) => ({key: index, ...option}));
export default SelectFilter;
